import { isFuture, isPast, parseISO } from 'date-fns';

export function usePromos() {
  const config = useRuntimeConfig();
  const promosConfig = config.public.promos;

  const isPromoActive = computed(() => {
    if (!promosConfig) return false;

    return isPast(promosConfig.startDate) && isFuture(promosConfig.endDate);
  });

  const startDate = promosConfig ? parseISO(promosConfig.startDate) : undefined;
  const endDate = promosConfig ? parseISO(promosConfig.endDate) : undefined;

  return { isPromoActive, startDate, endDate };
}
